import { render, staticRenderFns } from "./Contadores.vue?vue&type=template&id=a0ba3108&scoped=true&"
import script from "./Contadores.vue?vue&type=script&lang=js&"
export * from "./Contadores.vue?vue&type=script&lang=js&"
import style0 from "./Contadores.vue?vue&type=style&index=0&id=a0ba3108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba3108",
  null
  
)

export default component.exports